import api from '../services/api';

type ApiErrorShape = {
  response?: { status?: number; data?: { message?: string; code?: string; error?: { message?: string } } };
  message?: string;
};

export function errorMessage(err: unknown, fallback = 'Something went wrong. Try again.'): string {
  const e = err as ApiErrorShape;
  return e?.response?.data?.error?.message || e?.response?.data?.message || fallback;
}

export function errorStatus(err: unknown): number | undefined {
  return (err as ApiErrorShape)?.response?.status;
}

export function errorCode(err: unknown): string | undefined {
  return (err as ApiErrorShape)?.response?.data?.code;
}

/** Stored documents need the bearer token, so fetch as a blob and open an object URL. */
export async function openProtectedFile(url: string): Promise<void> {
  const tab = window.open('', '_blank');
  const { data, headers } = await api.get<Blob>(url, { responseType: 'blob', timeout: 120000 });
  const blob = new Blob([data], { type: String(headers['content-type'] || data.type || 'application/octet-stream') });
  const objectUrl = URL.createObjectURL(blob);
  if (tab) tab.location.href = objectUrl;
  else window.location.assign(objectUrl);
  setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
}
